var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhonecall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-21.2%",
    y: "-23.8%",
    width: "147.5%",
    height: "147.5%",
    filterUnits: "objectBoundingBox",
    id: "a6cpce5sda"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.647058824 0 0 0 0 0.678431373 0 0 0 0 0.741176471 0 0 0 0.7 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-21.2%",
    y: "-16.2%",
    width: "142.5%",
    height: "142.5%",
    filterUnits: "objectBoundingBox",
    id: "wi4an4u6ic"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.647058824 0 0 0 0 0.678431373 0 0 0 0 0.741176471 0 0 0 0.75 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "l1kkisatpb",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    id: "8lrx2inb5d",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "50%",
    x2: "50%",
    y2: "100%",
    id: "6l3xs3vfge"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 6)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a6cpce5sda)",
    xlinkHref: "#l1kkisatpb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#l1kkisatpb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 6)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#wi4an4u6ic)",
    xlinkHref: "#8lrx2inb5d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#6l3xs3vfge)",
    xlinkHref: "#8lrx2inb5d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M9 10h32v32H9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.091 22.17c1.11-.642 1.443-1.586.968-3.003-.476-1.417-2.046-5.292-3.87-4.803C15.365 14.853 12 15.908 12 20.11c0 4.203 2.863 7.6 7.124 11.923 4.262 4.323 14.098 8.406 16.886 4.203 2.789-4.203-.633-5.276-2.11-5.919-1.478-.643-4.386-1.716-5.013 0-.628 1.716-2.861.7-3.606 0-.745-.7-6.157-5.19-6.157-6.004 0-.815-.142-1.502.967-2.144z",
    stroke: "#22272A",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonecall);
export default __webpack_public_path__ + "static/media/phonecall.ae2feba16bfceb3d68537d325f1629ec.svg";
export { ForwardRef as ReactComponent };